var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background",style:({ backgroundImage: "url(/static/parallax-bg.jpg)", backgroundPosition: ("center " + (-_vm.scrolledSize/10) + "px") })})])}
var staticRenderFns = []

export { render, staticRenderFns }